import {connect} from 'react-redux';
import {reduxForm} from 'redux-form';
import {ff, form} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
const {Form, FormBody, FormActions} = form;
import CustomCheckboxField from "../components/CustomCheckboxField";
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Formulář pro tvorbu/úpravu sazeb DPH.
 */
class SazbaDphForm extends Component<WithTranslation> {

    static formName = 'SazbaDphForm';

    render() {
        const {onClose, submitting, handleSubmit, t} = this.props;
        return <Form onSubmit={handleSubmit} horizontal>
            <FormBody>
                <ff.String label={t('labels.name')} name="nazevDph" required disabled={submitting}/>
                <ff.String label={t('labels.code')} name="kodDph" required disabled={submitting}/>
                <ff.Number double label={t('rate')} name="sazba" required disabled={submitting}/>
                <CustomCheckboxField label={t('labels.inactive')} name="neaktivni" disabled={submitting}/>
            </FormBody>
            <FormActions onClose={onClose} storeButton={t('save')} cancelButton={t('buttons.cancel')} disabled={submitting}/>
        </Form>
    }
}

export default withTranslation()(connect()(reduxForm({
    form: SazbaDphForm.formName,
})(SazbaDphForm)));
